import { Injectable } from "@angular/core";

import { Completion, CompletionSource, CompletionResult, CompletionContext } from "@codemirror/autocomplete";

import { CodeEditorBlock } from "../../models";
import { SqlVariableCompletionConfig } from "../models";


@Injectable()
export class SqlEditorVariableCompletionService {

    public getVariableCompletionSource(config: SqlVariableCompletionConfig): CompletionSource {
        return context => this.variableAutocomplete(config, context);
    }

    private variableAutocomplete(config: SqlVariableCompletionConfig, context: CompletionContext): CompletionResult {
        try {
            if (!config?.prefix?.length || !config?.variables?.length || !context) return null;

            // Get the block of text preceding the cursor.
            const before: CodeEditorBlock = this.getBeforeBlock(context);

            // If it does not start with the variable prefix, return.
            if (!before || !before.text.startsWith(config.prefix)) return null;

            const completions: Completion[] = this.getVariableCompletions(config);

            return {
                from: before.from ?? context.pos,
                options: completions,
                validFor: /\S+/
            }

        } catch (error) {
            return null;
        }
    }

    private getVariableCompletions(config: SqlVariableCompletionConfig): Completion[] {
        return config.variables.map(variable => <Completion>{ label: `${config.prefix}${variable}` });
    }

    private getBeforeBlock(context: CompletionContext): CodeEditorBlock {
        return context.matchBefore(/\S+$/);
    }
}